import { Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';
import { GoogleMapsApiService } from './google-maps-api.service';
import { filter, switchMap, tap } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { GoogleMapsUtilsService } from './google-maps-utils.service';
import PlaceResult = google.maps.places.PlaceResult;

@Directive({
  selector: '[appGooglePlaceAutocomplete]'
})
export class GooglePlaceAutocompleteDirective implements OnDestroy {

  @Output() onSelect: EventEmitter<PlaceResult> = new EventEmitter();
  private element: HTMLInputElement;
  private sub: Subscription;

  constructor(
    private readonly elRef: ElementRef,
    private readonly googleMapsApiService: GoogleMapsApiService,
    private readonly googleMapsUtilsService: GoogleMapsUtilsService,
  ) {
    this.element = elRef.nativeElement;
  }

  ngOnInit() {
    this.sub = this.googleMapsApiService.googleApiLoaded$.pipe(
      filter((loaded) => !!loaded),
      switchMap(() => this.googleMapsUtilsService.getPlaceAutocomplete(this.elRef)),
      tap((result) => this.onSelect.emit(result))
    ).subscribe();
  }

  ngOnDestroy() {
    if (this.sub && !this.sub.closed) {
      this.sub.unsubscribe();
    }
  }

}
